import React from 'react';
import PropTypes from 'prop-types';

import styles from './FeatureCard.scss';

const FeatureCard = ({ card }) => {
  return (
    <a
      className={styles.card}
      key={card.header}
      href={card.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img alt={card.header} className={styles.image} src={card.img_src} />
      <h2 className={`${styles.header} mt-md`}>{card.header}</h2>
      <p className={styles.description}>{card.description}</p>
      <div className={styles.link}>{card.link_copy}</div>
    </a>
  );
};

FeatureCard.propTypes = {
  card: PropTypes.shape({
    url: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    img_src: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    link_copy: PropTypes.string.isRequired
  }).isRequired
};

export default FeatureCard;
